import React, { FC } from "react";

import { ProfileProvider, useProfileContext } from "Auth/contexts";
import { FullUserProfileProvider } from "./FullUserProfileProvider";

const BandProfileProvider: React.FC = ({ children }) => {
  const { currentUser } = useProfileContext();

  return (
    <FullUserProfileProvider user={currentUser}>
      {children}
    </FullUserProfileProvider>
  );
};

export const WrappedBandProfileProvider: FC = ({ children }) => (
  <ProfileProvider>
    <BandProfileProvider children={children} />
  </ProfileProvider>
);
